import { useEffect, useState } from "react";
import { usePosterContext } from "../../../context/poster-context";
import { PosterTemplateGrade } from "../../../hooks/use-poster";
import {
  EditLine,
  EditTabHeader,
  EditTabHeaderItem,
  EditWrapper,
} from "../styles";
import { TemplateItem, TemplateWrapper } from "./styles/template.style";

interface TemplateItem {
  id: number;
  image: string;
  type: string;
}

const TEMPLATE_LIST = [
  {
    id: 1,
    image: "/image-web/poster/template/template_1.png",
    type: "standard",
  },
  {
    id: 2,
    image: "/image-web/poster/template/template_2.png",
    type: "standard",
  },
  {
    id: 3,
    image: "/image-web/poster/template/template_3.png",
    type: "standard",
  },
];

const EditTemplate = () => {
  const {
    templateGrade,
    setTemplateGrade,
    selectedTournament,
    selectedTemplate,
    setSelectedTemplate,
  } = usePosterContext();

  const [templateList, setTemplateList] = useState<TemplateItem[]>([]);

  useEffect(() => {
    if (templateGrade === PosterTemplateGrade.ALL) {
      setTemplateList(TEMPLATE_LIST);
    } else if (templateGrade === PosterTemplateGrade.STANDARD) {
      setTemplateList(TEMPLATE_LIST.filter((item) => item.type === "standard"));
    } else if (templateGrade === PosterTemplateGrade.PREMIUM) {
      setTemplateList(TEMPLATE_LIST.filter((item) => item.type === "premium"));
    }
  }, [templateGrade]);

  return (
    <EditWrapper>
      <EditTabHeader>
        <div className="list">
          <EditTabHeaderItem
            selected={templateGrade === PosterTemplateGrade.ALL}
            onClick={() => setTemplateGrade(PosterTemplateGrade.ALL)}
          >
            전체
          </EditTabHeaderItem>
          <EditTabHeaderItem
            selected={templateGrade === PosterTemplateGrade.STANDARD}
            onClick={() => setTemplateGrade(PosterTemplateGrade.STANDARD)}
          >
            스탠다드
          </EditTabHeaderItem>
          <EditTabHeaderItem
            selected={templateGrade === PosterTemplateGrade.PREMIUM}
            onClick={() => setTemplateGrade(PosterTemplateGrade.PREMIUM)}
          >
            프리미엄
          </EditTabHeaderItem>
        </div>
      </EditTabHeader>
      <EditLine />
      <TemplateWrapper isEmpty={templateList.length === 0}>
        {templateList.length === 0 && <>준비중입니다.</>}
        {templateList.map((item) => (
          <TemplateItem
            key={item.id}
            selected={selectedTemplate === item.id}
            image={item.image}
            onClick={() => setSelectedTemplate(item.id)}
          />
        ))}
      </TemplateWrapper>
    </EditWrapper>
  );
};

export default EditTemplate;
